/** Feature entry renders the one declared page. */
import type { InsightsRenderReady } from '../../insightsRenderContract'
import type { InsightsLifecycle } from '../../pages/insights.page'
import { InsightPageRenderer } from './cards/InsightPageRenderer'
import { InsightSetupsSection, type TestInsightSetup } from './InsightSetupsSection'
export function InsightsDelivery({
  data,
  onTestSetup,
  lifecycle,
}: {
  data: InsightsRenderReady
  onTestSetup?: TestInsightSetup
  lifecycle: InsightsLifecycle
}) {
  let content = <InsightPageRenderer page={data.composition.page} />
  if (onTestSetup)
    content = (
      <InsightSetupsSection
        page={data.composition.page}
        revision={data.context.revision}
        onTestSetup={onTestSetup}
        lifecycle={lifecycle}
      />
    )
  return content
}
